module.exports = __webpack_public_path__ + "img/controller-generic.67158556.png";